import { rebind, merge } from "../utils";
import { darvasBox as darvasBoxCalculator } from "../calculator";
import baseIndicator from "./baseIndicator";

const ALGORITHM_TYPE = "DarvasBox";

export default function () {
  const base = baseIndicator()
    .type(ALGORITHM_TYPE)
    .accessor((d) => d.darvasBox);

  const underlyingAlgorithm = darvasBoxCalculator();

  const mergedAlgorithm = merge()
    .algorithm(underlyingAlgorithm)
    .merge((datum, indicator) => {
      // DarvasBox calculator returns object with multiple fields
      if (indicator) {
        datum.darvasBox = indicator.darvasBox;
        datum.ghostBox = indicator.ghostBox;
        datum.lossLevel = indicator.lossLevel;
        datum.profitLevel = indicator.profitLevel;
        datum.athIndex = indicator.athIndex;
        datum.volumeSpikeMarker = indicator.volumeSpikeMarker;
      }
    });

  const indicator = function (data, options = { merge: true }) {
    if (options.merge) {
      if (!base.accessor()) {
        throw new Error("Set accessor first for Darvas Box");
      }
      return mergedAlgorithm(data);
    }
    return underlyingAlgorithm(data);
  };

  rebind(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
  rebind(indicator, underlyingAlgorithm, "options", "undefinedLength");
  rebind(indicator, mergedAlgorithm, "merge", "skipUndefined");

  return indicator;
}
